<template>
  <v-container fluid class="pa-0 pt-2">
    <v-row>
      <!-- Other Information Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="blue darken-2" small
                >mdi-information-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Other Information
              </h3>
            </div>
          </div>
          <v-card-text class="px-4 py-1 font-size-16">
            <table width="100%">
              <tr
                v-for="(field, index) in tOneFields"
                :key="'tOneFields' + index"
              >
                <td
                  style="width: 170px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  {{ field.title }}
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="dataLoading">
                    <v-skeleton-loader
                      class="custom-skeleton width-80"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <template v-if="field.child && detail[field.key]">
                      {{ detail[field.key][field.child] }}
                    </template>
                    <template v-else-if="detail[field.key]">
                      <template
                        v-if="
                          field.key == 'end_life' ||
                          field.key == 'activation_date' ||
                          field.key == 'installation_date'
                        "
                      >
                        {{ formatDate(detail[field.key]) }}
                      </template>
                      <template v-else-if="field.key == 'serial_no'">
                        <v-chip
                          color="cyan"
                          label
                          small
                          text-color="white"
                          class="font-weight-600"
                        >
                          {{ detail[field.key] }}
                        </v-chip>
                      </template>
                      <template v-else-if="field.key == 'location'">
                        {{ detail[field.key].text }}
                      </template>
                      <template v-else-if="field.key == 'property'">
                        {{ detail[field.key].property_address }}
                      </template>
                      <template v-else-if="field.key == 'customer'">
                        {{ detail[field.key].company_name }}
                      </template>
                      <template v-else>
                        {{ detail[field.key] }}
                      </template>
                    </template>
                    <template v-else>
                      <em class="text-muted">No {{ field.title }}</em>
                    </template>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Warranty Information Card -->
      <v-col
        cols="12"
        md="6"
        v-if="
          detail &&
          detail.has_warranty == 1 &&
          detail.warranty &&
          detail.warranty.start_date
        "
      >
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="cyan darken-2" small
                >mdi-shield-check-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase mr-2"
              >
                Warranty Information
              </h3>
            </div>
            <template
              v-if="detail && detail.warranty && detail.warranty.status"
            >
              <v-chip
                small
                label
                text-color="white"
                class="font-weight-600"
                :color="getStatusColor(detail.warranty.status)"
                v-if="detail.warranty.status"
              >
                {{ getStatusText(detail.warranty.status) }}
              </v-chip>
            </template>
          </div>
          <v-card-text class="px-4 py-1 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Warranty #
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.warranty && detail.warranty.unique_id
                    "
                  >
                    <Barcode
                      route="warranty.detail"
                      :barcode="detail.warranty.unique_id"
                      :id="detail.warranty.id"
                    >
                    </Barcode>
                  </template>
                  <template v-else>
                    <em class="text-muted">no serial no</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Start Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.warranty && detail.warranty.start_date
                    "
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="green"
                      class="font-weight-600"
                    >
                      {{ formatDate(detail.warranty.start_date) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <em class="text-muted">no start date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  End Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-600 border-bottom-dashed"
                >
                  <template
                    v-if="detail && detail.warranty && detail.warranty.end_date"
                  >
                    <v-chip
                      outlined
                      class="mr-2 font-weight-600"
                      label
                      small
                      color="blue"
                    >
                      {{ formatDate(detail.warranty.end_date) }}
                    </v-chip>
                    <span
                      class="blue--text font-weight-700 text-nowrap py-1 d-inline-block"
                      v-if="totalDays(detail.warranty.end_date) > 0"
                    >
                      ( {{ totalDays(detail.warranty.end_date) }} Days )
                    </span>
                  </template>
                  <template v-else>
                    <em class="text-muted">no End date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Cost
                </td>
                <td valign="middle" class="py-1 font-size-18 font-weight-600">
                  <template
                    v-if="detail && detail.warranty && detail.warranty.cost"
                  >
                    <v-chip
                      outlined
                      label
                      small
                      color="blue"
                      class="font-weight-600"
                    >
                      {{ formatMoney(detail.warranty.cost) }}
                    </v-chip>
                  </template>
                  <template v-else>
                    {{ detail.pm_one_serial_number }}
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Delivery Info Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="green darken-2" small
                >mdi-truck-delivery-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Delivery Info
              </h3>
            </div>
          </div>
          <v-card-text class="px-4 py-1 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Do No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.do_no">
                    {{ detail.do_no }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Do No. </em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Commission Certificate No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.common_cert_no">
                    {{ detail.common_cert_no }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Commission Certificate No.</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Arrival Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.arrival_date">
                    {{ formatDate(detail.arrival_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no arrival date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Delivery Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.delivery_date">
                    {{ formatDate(detail.delivery_date) }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Delivery Date</em>
                  </template>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 210px"
                  valign="top"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Delivery Remark
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <template v-if="detail && detail.delivery_remark">
                    {{ detail.delivery_remark }}
                  </template>
                  <template v-else>
                    <em class="text-muted"> no Delivery Remark</em>
                  </template>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Asset Purchase Information Card -->
      <v-col cols="12" md="6">
        <v-card outlined elevation="0" class="mb-4 h-100">
          <div
            class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-2" color="purple darken-2" small
                >mdi-cart-outline</v-icon
              >
              <h3
                class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
              >
                Asset Purchase Information
              </h3>
            </div>
          </div>
          <v-card-text class="px-4 py-1 font-size-16">
            <table width="100%">
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Sales Person
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.salesperson">
                    {{ detail.salesperson }}
                  </template>
                  <em class="text-muted" v-else> no sales person </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Supplier
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template
                    v-if="
                      detail && detail.supplier && detail.supplier.display_name
                    "
                  >
                    {{ detail.supplier.display_name }}
                  </template>
                  <em class="text-muted" v-else> no supplier </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Purchase Date
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.purchase_date">
                    {{ formatDate(detail.purchase_date) }}
                  </template>
                  <em class="text-muted" v-else> no purchased date </em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Purchase Price
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.purchase_price">
                    <v-chip
                      outlined
                      label
                      small
                      color="blue"
                      class="font-weight-600"
                    >
                      {{ formatMoney(detail.purchase_price) }}
                    </v-chip>
                  </template>
                  <em v-else class="text-muted"> no Purchase Price</em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                >
                  Quotation No.
                </td>
                <td
                  valign="middle"
                  class="py-1 font-weight-600 font-size-18 border-bottom-dashed"
                >
                  <template v-if="detail && detail.quotation_no">
                    {{ detail.quotation_no }}
                  </template>
                  <em v-else class="text-muted"> no quotation no.</em>
                </td>
              </tr>
              <tr>
                <td
                  style="width: 170px"
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500"
                >
                  Invoice No.
                </td>
                <td valign="middle" class="py-1 font-weight-600 font-size-18">
                  <template v-if="detail && detail.invoice_no">
                    {{ detail.invoice_no }}
                  </template>
                  <em v-else class="text-muted"> no invoice no.</em>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-col>
      <template v-if="false">
        <v-card
          flat
          class="width-100 custom-grey-border remove-border-radius mb-4"
        >
          <v-card-title class="width-100">
            <th
              colspan="2"
              class="width-100 font-size-16 color-custom-blue grey lighten-4 py-1 text-uppercase"
            >
              Elevator/Motor Information
            </th>
          </v-card-title>
          <v-card-text class="p-6 font-size-16">
            <v-layout class="mb-4">
              <v-flex md6 class="custom-border-right">
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Motor Info</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Type of Machine
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.type_of_machine">
                          {{ detail.type_of_machine }}
                        </template>
                        <em class="text-muted" v-else> no type of machine </em>
                      </td>
                    </tr>

                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Power
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rated_power">
                          {{ detail.rated_power }}
                          <span
                            v-if="detail.rated_power_type"
                            class="font-weight-bold"
                            >({{ detail.rated_power_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else> no rated power </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Voltage
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rated_voltage">
                          {{ detail.rated_voltage }}
                          <span
                            v-if="detail.rated_voltage_type"
                            class="font-weight-bold"
                            >({{ detail.rated_voltage_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else> no rated voltage </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Current
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rated_current">
                          {{ detail.rated_current }}
                          <span
                            v-if="detail.rated_current_type"
                            class="font-weight-bold"
                            >({{ detail.rated_current_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else> no rated current </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Frequency
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.frequency">
                          {{ detail.frequency }}
                          <span
                            v-if="detail.frequency_type"
                            class="font-weight-bold"
                            >({{ detail.frequency_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else> no frequency </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Encode Shaft Diameter
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.encode_shaft_diameter">
                          {{ detail.encode_shaft_diameter }}
                          <span
                            v-if="detail.encode_shaft_diameter_type"
                            class="font-weight-bold"
                            >({{ detail.encode_shaft_diameter_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else>
                          no encode shaft diameter
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Rotational Speed
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.rated_rotational_speed"
                        >
                          {{ detail.rated_rotational_speed }}
                          <span
                            v-if="detail.rated_rotational_speed_type"
                            class="font-weight-bold"
                            >({{ detail.rated_rotational_speed_type }})</span
                          >
                        </template>
                        <em class="text-muted" v-else>
                          no rated rotational speed
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Motor Brand
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.elevator_brand">
                          {{ detail.elevator_brand }}
                        </template>
                        <em class="text-muted" v-else> no Motor brand </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Encoder Model
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.encoder_model">
                          {{ detail.encoder_model }}
                        </template>
                        <em class="text-muted" v-else> no encoder model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Traction Radio
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.traction_radio">
                          {{ detail.traction_radio }}
                        </template>
                        <em class="text-muted" v-else> no Traction radio </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Number of Rope
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.number_of_rope">
                          {{ detail.number_of_rope }}
                        </template>
                        <em class="text-muted" v-else> no number of rope </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rope Diameter
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rope_diameter">
                          {{ detail.rope_diameter }}
                        </template>
                        <em class="text-muted" v-else> no rope diameter </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Main Sheave Diameter
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.main_sheave_diameter">
                          {{ detail.main_sheave_diameter }}
                        </template>
                        <em class="text-muted" v-else>
                          no main sheave diameter
                        </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>
              <v-flex md6>
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Elevator Info</span
                  >
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td
                        class="font-size-18 font-weight-600 py-1"
                        style="width: 200px"
                      >
                        Address
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.address">
                          {{ detail.address }}
                        </template>
                        <em class="text-muted" v-else> no address </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Lift Number
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.lift_number">
                          {{ detail.lift_number }}
                        </template>
                        <em class="text-muted" v-else> no lift number </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Door Size
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_size">
                          {{ detail.door_size }}
                        </template>
                        <em class="text-muted" v-else> no door size </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Lift Type
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.lift_type">
                          {{ detail.lift_type }}
                        </template>
                        <em class="text-muted" v-else> no lift type </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Interconnected Door Floor
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.interconnected_door_floor"
                        >
                          {{ detail.interconnected_door_floor }}
                        </template>
                        <em class="text-muted" v-else>
                          no interconnected door floor
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td
                        class="font-size-18 font-weight-600 py-1"
                        style="width: 200px"
                      >
                        Drive System
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.drive_system">
                          {{ detail.drive_system }}
                        </template>
                        <em class="text-muted" v-else> no drive system </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Lift Brand
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.lift_brand">
                          {{ detail.lift_brand }}
                        </template>
                        <em class="text-muted" v-else> no lift brand </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Machine Room
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.machine_room">
                          {{ detail.machine_room }}
                        </template>
                        <em class="text-muted" v-else> no machine room </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Control System
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.control_system">
                          {{ detail.control_system }}
                        </template>
                        <em class="text-muted" v-else> no control system </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Load
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rated_load">
                          {{ detail.rated_load }}
                        </template>
                        <em class="text-muted" v-else> no rated load </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">Model</td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.elevator_model">
                          {{ detail.elevator_model }}
                        </template>
                        <em class="text-muted" v-else> no model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Speed
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.rated_speed">
                          {{ detail.rated_speed }}
                        </template>
                        <em class="text-muted" v-else> no rated speed </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Travel Distance
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.travel_distance">
                          {{ detail.travel_distance }}
                        </template>
                        <em class="text-muted" v-else> no travel distance </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Number of Stops
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.number_of_stops">
                          {{ detail.number_of_stops }}
                        </template>
                        <em class="text-muted" v-else> no number of stops </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Top Clearance
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.top_clearance">
                          {{ detail.top_clearance }}
                        </template>
                        <em class="text-muted" v-else> no top clearance </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Bottom Clearance
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.bottom_clearance">
                          {{ detail.bottom_clearance }}
                        </template>
                        <em class="text-muted" v-else> no bottom clearance </em>
                      </td>
                    </tr>

                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Installation Date
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.elevator_installation_date"
                        >
                          {{ formatDate(detail.elevator_installation_date) }}
                        </template>
                        <em class="text-muted" v-else>
                          no installation date
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        PTO Date
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.elevator_pto_date">
                          {{ formatDate(detail.elevator_pto_date) }}
                        </template>
                        <em class="text-muted" v-else> no PTO date </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card
          flat
          class="width-100 custom-grey-border remove-border-radius mb-4"
        >
          <v-card-title class="width-100">
            <th
              colspan="2"
              class="width-100 font-size-16 color-custom-blue grey lighten-4 py-1 text-uppercase"
            >
              Elevator Element Information
            </th>
          </v-card-title>
          <v-card-text class="p-6 font-size-16">
            <v-layout class="mb-4">
              <!-- Speed Governor Section -->
              <v-flex md6 class="custom-border-right">
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Speed Governor</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">Brand</td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.speed_governor_brand">
                          {{ detail.speed_governor_brand }}
                        </template>
                        <em class="text-muted" v-else> no brand </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Speed
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.speed_governor_rated_speed"
                        >
                          {{ detail.speed_governor_rated_speed }}
                        </template>
                        <em class="text-muted" v-else> no rated speed </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">Model</td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.speed_governor_model">
                          {{ detail.speed_governor_model }}
                        </template>
                        <em class="text-muted" v-else> no model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rope Diameter
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.speed_governor_rope_diameter"
                        >
                          {{ detail.speed_governor_rope_diameter }}
                        </template>
                        <em class="text-muted" v-else> no rope diameter </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Installation Date
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="
                            detail && detail.speed_governor_installation_date
                          "
                        >
                          {{
                            formatDate(detail.speed_governor_installation_date)
                          }}
                        </template>
                        <em class="text-muted" v-else>
                          no installation date
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Tensioning Mechanism
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.tensioning_mechanism">
                          {{ detail.tensioning_mechanism }}
                        </template>
                        <em class="text-muted" v-else>
                          no tensioning mechanism
                        </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>

              <!-- Elevator Car Section -->
              <v-flex md6>
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Elevator Car</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Size of Car
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.size_of_car">
                          {{ detail.size_of_car }}
                        </template>
                        <em class="text-muted" v-else> no size of car </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Control Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.control_board">
                          {{ detail.control_board }}
                        </template>
                        <em class="text-muted" v-else> no control board </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Height of Car
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.height_of_car">
                          {{ detail.height_of_car }}
                        </template>
                        <em class="text-muted" v-else> no height of car </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Lighting System
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.lighting_of_system">
                          {{ detail.lighting_of_system }}
                        </template>
                        <em class="text-muted" v-else> no lighting system </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Type of Car Door
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.type_of_car_door">
                          {{ detail.type_of_car_door }}
                        </template>
                        <em class="text-muted" v-else> no type of car door </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Ventilation System
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.ventilation_system">
                          {{ detail.ventilation_system }}
                        </template>
                        <em class="text-muted" v-else>
                          no ventilation system
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Car Door Width
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.car_door_width">
                          {{ detail.car_door_width }}
                        </template>
                        <em class="text-muted" v-else> no car door width </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Car Door Height
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.car_door_height">
                          {{ detail.car_door_height }}
                        </template>
                        <em class="text-muted" v-else> no car door Height </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Safety Device
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.car_safety_device">
                          {{ detail.car_safety_device }}
                        </template>
                        <em class="text-muted" v-else> no safety device </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Internal display board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.car_internal_display_board"
                        >
                          {{ detail.car_internal_display_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no internal display board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        External display board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.car_external_display_board"
                        >
                          {{ detail.car_external_display_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no external display board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Model of button
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.car_model_of_button">
                          {{ detail.car_model_of_button }}
                        </template>
                        <em class="text-muted" v-else> no model of button </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">Remark</td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.elevator_car_remark">
                          {{ detail.elevator_car_remark }}
                        </template>
                        <em class="text-muted" v-else> no remark </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>
            </v-layout>

            <!-- Door Operator Section -->
            <v-layout class="mb-4">
              <!-- Door Operator Section -->
              <v-flex md6 class="custom-border-right">
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Door Operator</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">Model</td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_operator_model">
                          {{ detail.door_operator_model }}
                        </template>
                        <em class="text-muted" v-else> no model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Power
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.door_operator_rated_power"
                        >
                          {{ detail.door_operator_rated_power }}
                          <span v-if="detail.door_operator_rated_power_unit">
                            ({{ detail.door_operator_rated_power_unit }})
                          </span>
                        </template>
                        <em class="text-muted" v-else> no rated power </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Current
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.door_operator_rated_current"
                        >
                          {{ detail.door_operator_rated_current }}
                          <span v-if="detail.door_operator_rated_current_unit">
                            ({{ detail.door_operator_rated_current_unit }})
                          </span>
                        </template>
                        <em class="text-muted" v-else> no rated current </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Voltage
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.door_operator_rated_voltage"
                        >
                          {{ detail.door_operator_rated_voltage }}
                          <span v-if="detail.door_operator_rated_voltage_unit">
                            ({{ detail.door_operator_rated_voltage_unit }})
                          </span>
                        </template>
                        <em class="text-muted" v-else> no rated voltage </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rated Frequency
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.door_operator_rated_frequency"
                        >
                          {{ detail.door_operator_rated_frequency }}
                          <span
                            v-if="detail.door_operator_rated_frequency_unit"
                          >
                            ({{ detail.door_operator_rated_frequency_unit }})
                          </span>
                        </template>
                        <em class="text-muted" v-else> no rated frequency </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Rope Belt
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.door_operator_rope_belt"
                        >
                          {{ detail.door_operator_rope_belt }}
                        </template>
                        <em class="text-muted" v-else> no rope belt </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Door Wheel Model
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_wheel_model">
                          {{ detail.door_wheel_model }}
                        </template>
                        <em class="text-muted" v-else> no door wheel model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Door Wheel Model 2
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_wheel_model_2">
                          {{ detail.door_wheel_model_2 }}
                        </template>
                        <em class="text-muted" v-else> no door wheel model </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Model of Door Strike
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.model_of_door_strike">
                          {{ detail.model_of_door_strike }}
                        </template>
                        <em class="text-muted" v-else>
                          no model of door strike
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Door Lock Model
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_lock_model">
                          {{ detail.door_lock_model }}
                        </template>
                        <em class="text-muted" v-else> no door lock model </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>

              <!-- Control Panel Section -->
              <v-flex md6>
                <v-card-title class="headline secondary lighten-5 py-1">
                  <span
                    class="font-weight-700 custom-headline color-custom-blue width-100 grey lighten-4 text-uppercase px-1 font-size-16"
                    >Control Panel</span
                  >
                </v-card-title>
                <v-card-text class="pa-4">
                  <table width="100%">
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Main Controller Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.main_controller_board">
                          {{ detail.main_controller_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no main controller board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Safety Circuit Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.safety_circuit_board">
                          {{ detail.safety_circuit_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no safety circuit board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Control Panel Inverter
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template
                          v-if="detail && detail.control_panel_inverter"
                        >
                          {{ detail.control_panel_inverter }}
                        </template>
                        <em class="text-muted" v-else>
                          no control panel inverter
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Power Supply Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.power_supply_board">
                          {{ detail.power_supply_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no power supply board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Door Controller Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.door_controller_board">
                          {{ detail.door_controller_board }}
                        </template>
                        <em class="text-muted" v-else>
                          no door controller board
                        </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Expansion Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.expansion_board">
                          {{ detail.expansion_board }}
                        </template>
                        <em class="text-muted" v-else> no expansion board </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Comm Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.comm_board">
                          {{ detail.comm_board }}
                        </template>
                        <em class="text-muted" v-else> no comm board </em>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-600 py-1">
                        Display Board
                      </td>
                      <td class="font-weight-600 font-size-18 py-1">
                        <template v-if="detail && detail.display_board">
                          {{ detail.display_board }}
                        </template>
                        <em class="text-muted" v-else> no display board </em>
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card></template
      >

      <v-col cols="6" v-if="false">
        <div class="gray-background h-100 border-left">
          <table class="width-100">
            <tr>
              <th
                colspan="2"
                class="font-size-16 color-custom-blue py-1 text-uppercase"
              >
                Asset Purchase Information
              </th>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1" width="200">
                Sales Person
              </td>
              <td class="font-weight-600 font-size-18 py-1">
                <template v-if="detail && detail.salesperson">
                  {{ detail.salesperson }}
                </template>
                <em class="text-muted" v-else> no sales person </em>
              </td>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1">Supplier</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail && detail.supplier && detail.supplier.display_name
                  "
                >
                  {{ detail.supplier.display_name }}
                </template>
                <em class="text-muted" v-else> no supplier </em>
              </td>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1">Purchase Date</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template v-if="detail && detail.purchase_date">
                  {{ formatDate(detail.purchase_date) }}
                </template>
                <em class="text-muted" v-else> no purchased date </em>
              </td>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1">Purchase Price</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template v-if="detail && detail.purchase_price">
                  <v-chip outlined text-color="" label small color="blue">
                    {{ formatMoney(detail.purchase_price) }}
                  </v-chip>
                </template>
                <em v-else class="text-muted"> no Purchase Price</em>
              </td>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1">Quotation No.</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template v-if="detail && detail.quotation_no">
                  {{ detail.quotation_no }}
                </template>
                <em v-else class="text-muted"> no quotation no.</em>
              </td>
            </tr>
            <tr class="">
              <td class="font-size-18 font-weight-500 py-1">Invoice No.</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template v-if="detail && detail.invoice_no">
                  {{ detail.invoice_no }}
                </template>
                <em v-else class="text-muted"> no invoice no.</em>
              </td>
            </tr>
          </table>
        </div>
      </v-col>

      <v-col
        cols="6"
        v-if="
          detail &&
          detail.has_preventive_maintanance == 1 &&
          detail.preventive_maintanance &&
          detail.preventive_maintanance.start_date
        "
      >
        <div class="gray-background h-100 pa-3 border-left">
          <!-- Preventive Maintenance -->
          <table class="width-100">
            <tr>
              <th colspan="2" class="font-size-19 color-custom-blue py-1">
                Preventive Maintenance Information
              </th>
            </tr>
            <tr class="line-height5">
              <td class="font-size-18 font-weight-500 py-1" width="200px">
                Preventive Maintenance #
              </td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail &&
                    detail.preventive_maintanance &&
                    detail.preventive_maintanance.unique_id
                  "
                >
                  <Barcode
                    route="preventive-maintanance.detail"
                    :barcode="detail.preventive_maintanance.unique_id"
                    :id="detail.preventive_maintanance.id"
                  >
                  </Barcode>
                </template>
                <template v-else> no serial no </template>
              </td>
            </tr>
            <tr class="line-height5">
              <td class="font-size-18 font-weight-500 py-1">Start Date</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail &&
                    detail.preventive_maintanance &&
                    detail.preventive_maintanance.start_date
                  "
                >
                  <v-chip outlined text-color="" label small color="green">
                    {{ formatDate(detail.preventive_maintanance.start_date) }}
                  </v-chip>
                </template>
                <template v-else> no start date </template>
              </td>
            </tr>
            <tr class="line-height5">
              <td class="font-size-18 font-weight-500 py-1">End Date</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail &&
                    detail.preventive_maintanance &&
                    detail.preventive_maintanance.end_date
                  "
                >
                  <v-chip outlined class="mr-2" label small color="red">
                    {{ formatDate(detail.preventive_maintanance.end_date) }}
                  </v-chip>
                  <!-- <span
                      class="red--text font-weight-700 text-nowrap d-inline-block py-1"
                      v-if="totalDays(detail.preventive_maintanance.end_date) > 0"
                    >
                      (
                      {{ totalDays(detail.preventive_maintanance.end_date) }}
                      Days )
                    </span> -->
                </template>
                <template v-else> no End date </template>
              </td>
            </tr>
            <tr class="line-height5">
              <td class="font-size-18 font-weight-500 py-1">
                Maintenance Cost
              </td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail &&
                    detail.preventive_maintanance &&
                    detail.preventive_maintanance.cost
                  "
                >
                  <v-chip outlined text-color="" label small color="blue">
                    {{ formatMoney(detail.preventive_maintanance.cost) }}
                  </v-chip>
                </template>
                <template v-else>
                  {{ detail.pm_one_serial_number }}
                </template>
              </td>
            </tr>
            <tr class="line-height5">
              <td class="font-size-18 font-weight-500 py-1">Status</td>
              <td class="font-weight-600 font-size-18 py-1">
                <template
                  v-if="
                    detail &&
                    detail.preventive_maintanance &&
                    detail.preventive_maintanance.status
                  "
                >
                  <v-chip
                    small
                    label
                    text-color="white"
                    :color="
                      getStatusColor(detail.preventive_maintanance.status)
                    "
                    v-if="detail.preventive_maintanance.status"
                  >
                    {{ getStatusText(detail.preventive_maintanance.status) }}
                  </v-chip>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </v-col>
      <v-col cols="12">
        <v-card flat class="custom-grey-border remove-border-radius">
          <v-card-title class="headline grey lighten-4 py-2">
            <span
              class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
            >
              <div class="d-flex align-center">
                <v-icon class="mr-2" color="cyan darken-2" small
                  >mdi-certificate-outline</v-icon
                >
                <h3
                  class="font-size-18 font-weight-700 mb-0 color-custom-blue text-uppercase"
                >
                  Skills , Licence & Certs Information
                </h3>
              </div>
            </span>
          </v-card-title>
          <v-card-text class="p-6 font-size-16">
            <v-simple-table fixed-header max-height="67vh">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="simple-table-th px-2">#</th>
                    <th class="simple-table-th px-2">Color</th>
                    <th class="simple-table-th px-2">Name</th>
                    <th class="simple-table-th px-2">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="detail?.certificates?.length > 0">
                    <tr
                      v-for="(row, index) in detail.certificates"
                      :key="index"
                      :class="{
                        'custom-border-top': index == 0,
                        'orange_lighten-5': index % 2 == 0,
                      }"
                    >
                      <td class="simple-table-td">{{ index + 1 }}</td>
                      <td class="simple-table-td">
                        <v-chip
                          small
                          :color="row.color"
                          label
                          style="height: 18px; min-width: 26px"
                        ></v-chip>
                      </td>
                      <td class="simple-table-td">
                        {{ row.name }}
                      </td>
                      <td class="simple-table-td">
                        {{ row.type }}
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template v-if="dataLoading">
                      <tr v-for="row in 5" :key="row">
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                        <td>
                          <v-skeleton-loader
                            type="text"
                            class="custom-skeleton table-rows-text"
                          ></v-skeleton-loader>
                        </td>
                      </tr>
                    </template>
                    <tr v-else-if="!dataLoading">
                      <td colspan="3">
                        <p
                          class="m-0 row-not-found text-center font-weight-500 font-size-16"
                        >
                          <img
                            :src="$assetURL('media/error/empty.png')"
                            class="row-not-found-image"
                          />
                          Uhh... There are no row at the moment.
                        </p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <template
        v-if="
          detail.faulty ||
          detail.retired ||
          (detail.has_warranty == 1 &&
            detail.warranty &&
            detail.warranty.start_date)
        "
      >
        <v-col cols="6" v-if="false && detail.is_purchase_info == 1">
          <div class="gray-background h-100 pa-3 border-left">
            <table class="width-100">
              <tr>
                <th colspan="2" class="font-size-18 py-1"></th>
              </tr>
              <tr>
                <th colspan="2" class="font-size-18 py-1">
                  Purchased Information
                </th>
              </tr>
              <tr class="line-height5">
                <td class="font-size-18 font-weight-500 py-1" width="250">
                  Supplier
                </td>
                <td class="font-weight-600 font-size-18 py-1">
                  <template
                    v-if="
                      detail && detail.supplier && detail.supplier.display_name
                    "
                  >
                    {{ detail.supplier.display_name }}
                  </template>
                  <em class="text-muted" v-else> no supplier </em>
                </td>
              </tr>
              <tr class="line-height5">
                <td class="font-size-18 font-weight-500 py-1" width="250">
                  Purchased On
                </td>
                <td class="font-weight-600 font-size-18 py-1">
                  <template v-if="detail && detail.purchased_on">
                    {{ formatDate(detail.purchased_on) }}
                  </template>
                  <em class="text-muted" v-else> no purchased date </em>
                </td>
              </tr>
              <tr class="line-height5">
                <td class="font-size-18 font-weight-500 py-1" width="250">
                  Cost Price
                </td>
                <td class="font-weight-600 font-size-18 py-1">
                  <template v-if="detail && detail.cost_price">
                    {{ formatMoney(detail.cost_price) }}
                  </template>
                  <em v-else class="text-muted"> no cost price</em>
                </td>
              </tr>
            </table>
          </div>
        </v-col>
        <v-col cols="6" v-if="false">
          <div class="gray-background h-100 pa-3 border-left">
            <table class="width-100">
              <tr>
                <th colspan="2" class="font-size-18 py-1" v-if="detail.faulty">
                  Faulty Remark
                </th>
                <th colspan="2" class="font-size-18 py-1" v-if="detail.retired">
                  Retired Remark
                </th>
              </tr>
              <tr class="line-height5">
                <td
                  class="font-weight-600 font-size-18 py-1"
                  style="line-height: normal"
                >
                  <template v-if="detail && detail.faulty">
                    <span>{{ detail.faulty_remark }}</span>
                  </template>
                  <template v-else-if="detail && detail.retired">
                    <span>{{ detail.retired_remark }}</span>
                  </template>
                  <em class="text-muted" v-else> no remark </em>
                </td>
              </tr>
            </table>
          </div>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment-timezone";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { toSafeInteger } from "lodash";
/* import { QUERY } from "@/core/services/store/request.module"; */
import CommonMixin from "@/core/plugins/common-mixin";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  mixins: [CommonMixin],
  data() {
    return {
      equipment: 0,
      dataLoading: true,
      chartOptions: {
        chart: {
          id: "equipment-summary",
        },
        xaxis: {
          categories: [],
        },
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: "'Poppins', Helvetica, Arial, sans-serif",
          },
        },
      },
      series: [],
      tOneFields: [
        {
          title: "Specification",
          key: "specification",
          child: false,
        },
        {
          title: "Brand",
          key: "brand",
          child: false,
        },
        // {
        //   title: "Model",
        //   key: "model",
        //   child: false,
        // },
        {
          title: "Category",
          key: "category",
          child: false,
        },
        {
          title: "Sub-Location",
          key: "location",
          child: false,
        },
        {
          title: "Description",
          key: "description",
          child: false,
        },
      ],
    };
  },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {
        return new Object();
      },
    },
  },
  watch: {
    detail: {
      deep: true,
      immediate: true,
      handler(param) {
        this.equipment = this.lodash.toSafeInteger(param.id);
        this.dataLoading = false;
      },
    },
  },
  methods: {
    getProfileImage() {
      if (!this.detail.image) {
        return null;
      }
      return this.detail.image;
    },
    /*   totalDays(end_date) {
        var a = moment(end_date, "yyyy-MM-DD");
        var b = moment();
        var final = a.diff(b, "days");
        return final;
      }, */
    totalDays(end_date) {
      let today = moment().format("YYYY-MM-DD");

      var a = moment(end_date);
      var b = moment(today); //date.start_date
      var final = a.diff(b, "days"); // =1
      if (final <= 0) {
        final = 0;
      }
      return final;
    },
    totalDaysEndLife(end_date) {
      var a = moment(end_date, "yyyy-MM-DD").add(1, "days");
      var b = moment();
      var final = a.diff(b, "days");
      return final;
    },
    getStatusText(data) {
      if (toSafeInteger(data) == 1) {
        return "Draft";
      } else if (toSafeInteger(data) == 2) {
        return "Active";
      } else if (toSafeInteger(data) == 3) {
        return "Extended";
      } else if (toSafeInteger(data) == 4) {
        return "Terminated";
      } else if (toSafeInteger(data) == 5) {
        return "Expired";
      }
    },
    getFormattedProperty(row) {
      let tempArr = [];
      if (row.unit_no) {
        tempArr.push(row.unit_no);
      }
      if (row.street_1) {
        tempArr.push(row.street_1);
      }
      if (row.street_2) {
        tempArr.push(row.street_2);
      }

      if (row.country) {
        tempArr.push(row.country);
      }
      return tempArr.join(", ");
    },
    getFormattedCompany() {
      let tempArr = [];
      if (this.detail.entity.unit_no) {
        tempArr.push(this.detail.entity.unit_no);
      }
      if (this.detail.entity.street_1) {
        tempArr.push(this.detail.entity.street_1);
      }
      if (this.detail.entity.street_2) {
        tempArr.push(this.detail.entity.street_2);
      }

      if (this.detail.entity.zip_code) {
        tempArr.push(this.detail.entity.zip_code);
      }
      if (this.detail.entity.landmark) {
        tempArr.push(this.detail.entity.landmark);
      } else {
        tempArr.push("Singapore");
      }
      /*   if (this.lodash.isEmpty(row.city) === false) {
          tempArr.push(row.city.name);
        }
        if (this.lodash.isEmpty(row.state) === false) {
          tempArr.push(row.state.name);
        }
        if (this.lodash.isEmpty(row.country) === false) {
          tempArr.push(row.country);
        } */
      return tempArr.join(", ");
    },
    getStatusColor(data) {
      if (toSafeInteger(data) == 1) {
        return "blue";
      } else if (toSafeInteger(data) == 2) {
        return "green";
      } else if (toSafeInteger(data) == 3) {
        return "orange";
      } else if (toSafeInteger(data) == 4) {
        return "red";
      } else if (toSafeInteger(data) == 5) {
        return "teal";
      }
    },
  },
  mounted() {
    /*  this.getSummary(); */
  },
  computed: {
    equipmentActivated() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.detail) === false) {
        return _this.detail.activated == 1 ? true : false;
      }
      return false;
    },
  },
  components: {
    Barcode,
  },
};
</script>
